import api from "./axios";

// ---------------------------------------------------------------------------
// Public
// ---------------------------------------------------------------------------

// Returns the flat, active-only menu tree used to render the public navbar.
export const getMenus = () => api.get("/api/menus/");

// ---------------------------------------------------------------------------
// Admin
// ---------------------------------------------------------------------------

export const adminGetMenus = () =>
  api.get("/api/admin/menus/");

export const adminGetMenu = (id) =>
  api.get(`/api/admin/menus/${id}/`);

export const adminCreateMenu = (data) =>
  api.post("/api/admin/menus/", data);

export const adminUpdateMenu = (id, data) =>
  api.put(`/api/admin/menus/${id}/`, data);

// Partial update — handy for quick toggles (e.g. isActive, order)
// without resubmitting every field.
export const adminPatchMenu = (id, data) =>
  api.patch(`/api/admin/menus/${id}/`, data);

export const adminDeleteMenu = (id) =>
  api.delete(`/api/admin/menus/${id}/`);